var _effectorFileName = "/builds/gmini/front-ui-kit/src/Dialog/Dialog.tsx";
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Backdrop } from '../Backdrop';
import { Paper } from '../Paper';
import { DialogRoot, DialogWrapper, PaperWrapper } from './Dialog.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Dialog = ({
  children,
  open = false,
  BackdropComponent = Backdrop,
  PaperComponent = Paper,
  maxWidth = 'sm',
  fullWidth = false,
  onClose,
  scroll = 'paper',
  ...props
}) => {
  const [isMounted, setIsMounted] = useState(false);
  const [isOpenStylesApplied, setIsOpenStylesApplied] = useState(false);
  useEffect(() => {
    const onEscDown = ({
      code
    }) => {
      if (code === 'Escape' && onClose) {
        onClose();
      }
    };

    document.addEventListener('keydown', onEscDown);
    return () => {
      document.removeEventListener('keydown', onEscDown);
    };
  }, [onClose]);
  useEffect(() => {
    if (open) {
      setIsMounted(true); //чтобы реакт не собирал их в один вызов, для транзишена

      setTimeout(() => setIsOpenStylesApplied(true), 0);
    }

    if (!open) {
      setIsOpenStylesApplied(false);
      setTimeout(() => setIsMounted(false), 225);
    }
  }, [open]);
  return isMounted ? /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsxs(DialogRoot, {
    role: "presentation",
    ...props,
    children: [/*#__PURE__*/_jsx(BackdropComponent, {
      open: isOpenStylesApplied,
      style: {
        opacity: isOpenStylesApplied ? 1 : 0,
        transition: isOpenStylesApplied ? 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'opacity 195ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
      },
      onClick: onClose
    }), /*#__PURE__*/_jsx(DialogWrapper, {
      role: "none presentation",
      open: isOpenStylesApplied,
      style: {
        opacity: isOpenStylesApplied ? 1 : 0,
        transition: isOpenStylesApplied ? 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'opacity 195ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
      },
      scroll: scroll,
      tabIndex: -1,
      children: /*#__PURE__*/_jsx(PaperWrapper, {
        PaperComponent: PaperComponent,
        scroll: scroll,
        maxWidth: maxWidth,
        fullWidth: fullWidth,
        children: children
      })
    })]
  }), document.body) : null;
};